import { usePathname, useSearchParams } from 'next/navigation';

export const useGetFullPath = () => {
  const pathname = usePathname();
  const searchParams = useSearchParams();
  // Safely handle null searchParams
  const fullPath = searchParams
    ? `${pathname}?${searchParams.toString()}`.replace(/\?$/, '') // Remove trailing "?" if no query params
    : pathname; // Fallback to just the pathname if searchParams is null

  return { fullPath };
};
